import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  franchise: null,
  franchises: null,
  franchiseOffices: [],
  isNew: false,
  lastState: null,
  lastScope: null,
  selectedTab: 'general'
};

const franchiseReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FRANCHISE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.FRANCHISE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.FRANCHISE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default franchiseReducer;
